import { Injectable } from '@angular/core';
import { DroplistItem, PageTabsLayoutPageService } from '@eforall/dashboard';


/**
 * The list of tabs on this page
 */
export enum ConfigurationEmailJobsPageTabId {
	EmailJobs = 1,
	Tab1 = 2,
	Tab2 = 3,
}

/**
 * The list if main tab droplist views on this page
 */
export enum ConfigurationEmailJobsPageViewId {
	EmailJobs = 1,
	EmailJobTriggers = 2,
}


@Injectable({ providedIn: 'root' })
export class ConfigurationEmailJobsService extends PageTabsLayoutPageService<ConfigurationEmailJobsPageTabId, ConfigurationEmailJobsPageViewId> {

	private static readonly _viewDroplistItems: DroplistItem<never, ConfigurationEmailJobsPageViewId>[] = [
		{
			uniqueId: ConfigurationEmailJobsPageViewId.EmailJobs,
			iconContext: {
				iconClass: 'fa-envelope',
				iconStyle: 'fa-solid',
				text: 'Email Jobs',
				hideText: 'never',
			},
			customSort: '1'
		},
		{
			uniqueId: ConfigurationEmailJobsPageViewId.EmailJobTriggers,
			iconContext: {
				iconClass: 'fa-bolt',
				iconStyle: 'fa-solid',
				text: 'Email Job Triggers',
				hideText: 'never',
			},
			customSort: '2'
		}
	];

	constructor() {
		super(ConfigurationEmailJobsService._viewDroplistItems, ConfigurationEmailJobsService.name, ConfigurationEmailJobsPageTabId.EmailJobs, ConfigurationEmailJobsPageViewId.EmailJobs);
	}

	public get viewId() {
		return ConfigurationEmailJobsPageViewId;
	}

}